import { FulfillmentOrderAddress } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { RedoFulfillmentLocation } from "@redotech/redo-fulfillment-group-common/fulfillment-location";
import { RedoShopifyCountryCode } from "@redotech/redo-inventory-common/fulfillment-country-code";

/**
 * Single origin (ship-from) address for the backend: the custom address, else
 * the selected location (with locationId), else null for the team default.
 */
export function resolveOriginAddress(
  location: RedoFulfillmentLocation | null,
  customLocation: FulfillmentOrderAddress | undefined,
): FulfillmentOrderAddress | null {
  if (customLocation !== undefined) {
    return customLocation;
  }
  if (location) {
    return mapLocationToOriginAddress(location);
  }
  return null;
}

export function mapLocationToOriginAddress(
  location: RedoFulfillmentLocation,
): FulfillmentOrderAddress {
  return {
    name: location.name,
    address1: location.address.address1,
    address2: location.address.address2,
    city: location.address.city,
    countryCode: location.address.countryCode as RedoShopifyCountryCode,
    province: location.address.province,
    zip: location.address.zip,
    phone: location.address.phone,
    locationId: location.externalId,
  };
}
